import { SBCategory } from "./categories.types";

export const getNames = <C extends SBCategory>(category: C): string =>
  category.name;
